/** Public URL encoded in ID card QR — opens student details page. */
export function getStudentCardQrUrl(studentId) {
  if (!studentId) return '';
  if (typeof window === 'undefined') return '';
  const origin = window.location.origin;
  const basePath = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  return `${origin}${basePath}#/student-card/${studentId}`;
}

/** CP Rawat Softwares product logo (Managed by). */
export function getCpRawatLogoUrl() {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const rel = `${base}/images/school-analytics-product-logo.png`;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${rel.startsWith('/') ? rel : `/${rel}`}`;
  }
  return rel;
}
